import { render, staticRenderFns } from "./PLPProductBox.vue?vue&type=template&id=6015ff2c&scoped=true"
import script from "./PLPProductBox.vue?vue&type=script&lang=ts"
export * from "./PLPProductBox.vue?vue&type=script&lang=ts"
import style0 from "./PLPProductBox.vue?vue&type=style&index=0&id=6015ff2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6015ff2c",
  null
  
)

export default component.exports